import React, { useContext, useEffect, useRef, useState } from 'react';
import { CARD_ANIMATION_DURATION_MS } from './utils/animationConfig';

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  const [activeCard, setActiveCard] = useState('');
  const [showContent, setShowContent] = useState(true);
  const [start, setStart] = useState(true);
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    const showTimer = setTimeout(() => {
      setShowContent(true);
    }, CARD_ANIMATION_DURATION_MS);

    return () => {
      clearTimeout(showTimer);
    };
  }, [activeCard]);

  return (
    <AppContext.Provider
      value={{
        start,
        setStart,
        activeCard,
        setActiveCard,
        showContent,
        setShowContent,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppContext, AppProvider };
